import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=1ff17bad&scoped=true"
import script from "./GroupsList.vue?vue&type=script&lang=js"
export * from "./GroupsList.vue?vue&type=script&lang=js"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=1ff17bad&prod&lang=scss&scoped=true"
import style1 from "./GroupsList.vue?vue&type=style&index=1&id=1ff17bad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff17bad",
  null
  
)

export default component.exports